// eslint-disable-next-line import/no-cycle
import FormatInput from './input';

export default FormatInput;
